import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  Tooltip,
  IconButton,
  Divider,
  Stack,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { BUILDING_TABLE_HEADERS } from "../../constant/TableHeaders";
import DeleteBuildingDialog from "./DeleteBuildingDialog";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import ViewBuildingDialog from "./ViewBuildingDialog";
import { ROUTE_BUILDERS } from "../../routes/routeBuilders";

const BuildingTable = ({ rows }) => {
  const navigate = useNavigate();
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedBuildingId, setSelectedBuildingId] = useState(null);
  const [selectedBuilding, setSelectedBuilding] = useState(null);

  const handleViewClick = (building) => {
    setSelectedBuilding(building);
    setOpenViewDialog(true);
  };

  const handleViewDialogClose = () => {
    setOpenViewDialog(false);
    setSelectedBuilding(null);
  };

  const handleEdit = (id) => {
    navigate(ROUTE_BUILDERS.BUILDING.EDIT(id));
  };

  const handleDeleteClick = (id) => {
    setSelectedBuildingId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setSelectedBuildingId(null);
  };

  const handleDeleteSuccess = () => {
    setTimeout(() => window.location.reload(), 1000);
  };

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 500 }} aria-label="building table">
          <TableHead>
            <TableHeaderRow>
              {BUILDING_TABLE_HEADERS.map((item, index) => (
                <TableCell
                  key={index}
                  align={item.alignItemTo}
                  sx={{ width: item.width }}
                >
                  {item.title}
                </TableCell>
              ))}
            </TableHeaderRow>
          </TableHead>

          <StyledTableBody>
            {rows.map((row) => (
              <TableBodyRow
                key={row.id}
                hover
                sx={{
                  "&:hover": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                  {row.building_name}
                </TableCell>
                <TableCell sx={{ width: 800, alignItemTo: "left" }}>
                  {row.building_address}
                </TableCell>
                <TableCell sx={{ width: 100, alignItemTo: "left" }}>
                  <Stack
                    direction="row"
                    spacing={1}
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Tooltip title="View" arrow>
                      <IconButton
                        onClick={() => handleViewClick(row)}
                        size="small"
                      >
                        <VisibilityOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit" arrow>
                      <IconButton
                        onClick={() => handleEdit(row.id)}
                        size="small"
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        onClick={() => handleDeleteClick(row.id)}
                        size="small"
                      >
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </TableCell>
              </TableBodyRow>
            ))}
          </StyledTableBody>
        </Table>
      </TableContainer>

      <ViewBuildingDialog
        open={openViewDialog}
        onClose={handleViewDialogClose}
        building={selectedBuilding}
      />

      <DeleteBuildingDialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        buildingId={selectedBuildingId}
        onSuccess={handleDeleteSuccess}
      />
    </>
  );
};

export default BuildingTable;
